import { style, media } from 'typestyle'
import { important } from 'csx'
export const pt16mdi = style(media({ maxWidth: 768 }, { paddingTop: important('16px') }))
